import Canvas from "@/components/ui/Canvas";
import { ICanvasProps } from "@/components/ui/Canvas/Models";
import {
  MapActiveIcon,
  MapActiveIconLocation,
  RenderIconNext,
  RenderIconPre
} from "@/components/ui/Icons/IconsCustom";
import TreeSelect from "@/components/ui/TreeSelect";
import { ITreeInfo } from "@/components/ui/TreeSelect/Models";
import { RootState } from "@/redux";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { IFilterResource } from "@/services";
import { cloneDeep } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { INextPrevLocationProps } from "./Model";
import {
  FloorPlanNextAndPrevWrapper,
  HeaderTitleWrapper,
  NextPrevLocationBaseWrapper,
  NextPrevLocationContentWrapper,
  RenderIconWrapper,
} from "./Style";

const NextPrevLocation = (props: INextPrevLocationProps) => {
  const { t } = useTranslation();
  const settingStore: ISettingStore = useSelector(
    (state: RootState) => state.settingInfo
  ) as ISettingStore;
  const state: RootState = useSelector(
    (state: RootState) => state
  ) as RootState;
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const filter: IFilterResource | null = state?.resources?.filterResource;
  const locationList = props.locationList || [];
  const listLocationHaveFloorPlan = props.listLocationHaveFloorPlan || [];

  const args: ICanvasProps = {
    headerTitle: (
      <HeaderTitleWrapper className="HeaderTitleWrapper">
        <MapActiveIcon theme={settingStore.theme} />
        <span>{t("Available Floor Plans")}</span>
      </HeaderTitleWrapper>
    ),
    isStickHeader: false,
    isOpen: isOpen,
  };

  const nextLocation = (indexLocation?: number) => {
    const filterClone = filter ? cloneDeep(filter) : ({} as IFilterResource);
    filterClone.indexLocation =
      indexLocation !== undefined
        ? indexLocation
        : (filterClone?.indexLocation || 0) + 1;
    if (props.updateFilterResource) {
      props.updateFilterResource(filterClone);
    }
  };

  const prevLocation = () => {
    const filterClone = filter ? cloneDeep(filter) : ({} as IFilterResource);
    filterClone.indexLocation = (filterClone?.indexLocation || 1) - 1;
    if (props.updateFilterResource) {
      props.updateFilterResource(filterClone);
    }
  };

  const renderNameLocation = (): string => {
    const locationInfo: ITreeInfo | undefined = locationList.find(
      (item) =>
        item.guid === listLocationHaveFloorPlan[filter?.indexLocation || 0]
    );
    if (locationInfo) {
      return locationInfo.name;
    }
    return "Locations";
  };

  const onChangeLocations = (arr: string[]) => {
    const indexLocation: number | undefined =
      listLocationHaveFloorPlan.findIndex((guid: string) => guid === arr[0]);
    if (indexLocation !== undefined && indexLocation !== -1) {
      nextLocation(indexLocation);
    }
  };

  return (
    <NextPrevLocationBaseWrapper className="NextPrevLocationBaseWrapper">
      <Canvas
        {...args}
        theme={settingStore.theme || undefined}
        rcName="resource_prev_next_dialog"
      >
        <NextPrevLocationContentWrapper className="NextPrevLocationContentWrapper">
          <TreeSelect
            items={props.dataTreeLocation || []}
            values={listLocationHaveFloorPlan[filter?.indexLocation || 0] ? [listLocationHaveFloorPlan[filter?.indexLocation || 0]] : []}
            size="small"
            onChange={onChangeLocations}
            iconLeft={<MapActiveIconLocation theme={settingStore.theme} />}
            iconLeftActive={<MapActiveIcon theme={settingStore.theme} />}
            displayLabelValue={t(renderNameLocation())}
            lblSelect={t("Locations")}
            expanded={
              listLocationHaveFloorPlan[filter?.indexLocation || 0]
                ? [listLocationHaveFloorPlan[filter?.indexLocation || 0]]
                : []
            }
            theme={settingStore?.theme || undefined}
            rcName="location_available_floorplan_dialog"
            isNotCheckbox
          />
          <FloorPlanNextAndPrevWrapper className="FloorPlanNextAndPrevWrapper">
            <RenderIconWrapper
              onClick={() =>
                !filter?.indexLocation ? undefined : prevLocation()
              }
              $isDisable={!filter?.indexLocation}
            >
              <RenderIconPre theme={settingStore.theme} />
            </RenderIconWrapper>
            <RenderIconWrapper
              onClick={() =>
                (filter?.indexLocation || 0) ===
                listLocationHaveFloorPlan.length - 1
                  ? undefined
                  : nextLocation()
              }
              $isDisable={
                (filter?.indexLocation || 0) ===
                listLocationHaveFloorPlan.length - 1
              }
            >
              <RenderIconNext theme={settingStore.theme} />
            </RenderIconWrapper>
          </FloorPlanNextAndPrevWrapper>
        </NextPrevLocationContentWrapper>
      </Canvas>
    </NextPrevLocationBaseWrapper>
  );
};

export default NextPrevLocation;
